import { render, staticRenderFns } from "./ClaimCode.vue?vue&type=template&id=71ef3866&"
import script from "./ClaimCode.js?vue&type=script&lang=js&"
export * from "./ClaimCode.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ClaimCode.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=https%3A%2F%2Fcdn.jsdelivr.net%2Fnpm%2F%40duetds%2Fdate-picker%401.3.0%2Fdist%2Fduet%2Fthemes%2Fdefault.css"
if (typeof block0 === 'function') block0(component)

export default component.exports